
import { CaretDownOutlined, DownOutlined, SmileOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Select } from 'antd';
import React, { useState } from 'react'

const RepresentativeContactForm = () => {
    const [disableTrueFalse, setDisableTrueFalse] = useState(true)
    const formItemLayout = {
        labelCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 8,
            },
        },
        wrapperCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 16,
            },
        },
    };
    const jobPositions=[
        {
            value: 'Frontend Developer'
        },
        {
            value: 'Backend Developer'
        },
        {
            value: 'Python Developer'
        },
        {
            value: 'Others'
        },
    ]
    return (

        <Col span={24} >
            <Form
                {...formItemLayout}
            >
                <Form.Item
                    name="First Name"
                    label="First Name"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your First Name!',
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='Amir'/>
                </Form.Item>
                <Form.Item
                    name="Last Name"
                    label="Last Name"

                    rules={[
                        {
                            required: true,
                            message: 'Please input Last Name!',
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='Ali'/>
                </Form.Item>
                <Form.Item
                    name="Mobile Number"
                    label="Mobile Number"
                    tooltip="This must be a phone number of a physical mobile phone that is able to receive SMS messages and be registered to the contact listed above."
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Mobile Number!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Row>
                        <Col span={24}>
                            <Input disabled={disableTrueFalse} defaultValue='4052390443'/>
                        </Col>

                        <Col span={24}>
                            <p
                                style={{ fontWeight: "200", fontSize: "0.9em", lineHeight: 1.6, color: 'gray' }}
                            >Do not use a Google Voice or other VoIP number.</p></Col>
                    </Row>
                </Form.Item>
                <Form.Item
                    name="Email Address"
                    label="Email Address"
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail!',
                        },
                        {
                            required: true,
                            message: 'Please input your Email Address!',
                            whitespace: true,
                        },

                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='amir@gmail.com'/>
                </Form.Item>
                <Form.Item
                    name="Job Position"
                    label="Job Position"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Job Position!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Select disabled={disableTrueFalse} defaultValue='Other' options={jobPositions}/>
                </Form.Item>
                <Form.Item
                    name="Business Title"
                    label="Business Title"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Business Title!',
                            whitespace: true,
                        },
                    ]}
                >
                    <Input disabled={disableTrueFalse} defaultValue='President'/>
                </Form.Item>
            </Form>
        </Col>
    )
}

export default RepresentativeContactForm;